import {
  AfterViewInit,
  Component,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DialogService } from 'primeng/dynamicdialog';
import { MenuModule } from 'primeng/menu';
import { SkeletonModule } from 'primeng/skeleton';
import { AccountDialog } from '../../dialogs/account-dialog/account-dialog';
import { ChangePassword } from '../../dialogs/change-password/change-password';
import { Auth } from '../../services/auth';
import { UserService } from '../../services/user';

@Component({
  selector: 'app-user-menu',
  imports: [MenuModule, ButtonModule, SkeletonModule, AvatarModule],
  templateUrl: './user-menu.html',
  styleUrl: './user-menu.css',
  standalone: true,
  providers: [DialogService],
})
export class UserMenu implements AfterViewInit {
  private dialogService = inject(DialogService);
  private authService = inject(Auth);
  public userService = inject(UserService);

  isDarkMode = signal(false);
  collapsed = input(false);
  userAvatar = computed(() =>
    this.userService.currentUser()?.email === 'fschmidt@impact-code.de'
      ? '/fabse.png'
      : undefined,
  );

  ngAfterViewInit() {
    // get the theme from the local storage
    const theme = localStorage.getItem('theme');
    if (theme) {
      this.isDarkMode.set(theme === 'dark');
      this.toggleDarkMode(theme as 'dark' | 'light');
    } else {
      this.toggleDarkMode('light');
    }
  }

  toggleDarkMode(mode: 'dark' | 'light') {
    const element = document.querySelector('html');
    if (element) {
      if (mode === 'dark') {
        element.classList.add('dark-theme');
        this.isDarkMode.set(true);
      } else {
        element.classList.remove('dark-theme');
        this.isDarkMode.set(false);
      }
    }
    // set the theme in the local storage
    localStorage.setItem('theme', this.isDarkMode() ? 'dark' : 'light');
  }

  items = computed(() => [
    {
      separator: true,
    },
    {
      label: $localize`Account`,
      icon: 'far fa-user',
      command: () => {
        this.openAccount();
      },
    },
    {
      label: $localize`Change Password`,
      icon: 'far fa-key',
      command: () => {
        this.changePassword();
      },
    },
    // {
    //   label: this.isDarkMode() ? 'Light Mode' : 'Dark Mode',
    //   icon: this.isDarkMode() ? 'far fa-sun' : 'far fa-moon',
    //   command: () => {
    //     this.toggleDarkMode(this.isDarkMode() ? 'light' : 'dark');
    //   },
    // },

    {
      separator: true,
    },

    {
      disabled: false,
      label: $localize`Logout`,
      icon: 'far fa-sign-out',
      command: () => {
        this.authService.logout();
      },
    },
  ]);

  changePassword() {
    this.dialogService.open(ChangePassword, {
      header: $localize`Change Password`,
      width: '450px',
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw',
      },
      modal: true,
      closable: true,
    });
  }

  openAccount() {
    this.dialogService.open(AccountDialog, {
      showHeader: false,
      width: '600px',
      breakpoints: {
        '768px': '100vw',
      },
      styleClass: 'account-dialog-panel',
      contentStyle: {
        padding: '0',
      },
      modal: true,
      closable: true,
      closeOnEscape: false,
    });
  }
}
